














import Vue from 'vue'
import * as R from 'ramda'
import { State } from 'vuex-class'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextSearchOrInput from '@/components/AppTextSearchOrInput.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import { User } from '@/modules/User/interfaces/user'
import { DrawerItem } from '@/interfaces/drawer'
import { CheckboxModel } from '../interfaces/checkbox-model.interface'

@Component({
  components: {
    AppTextarea,
    AppTextSearch,
    AppTextField,
    AppTextSearchOrInput,
    AppPhoneInput
  }
})
export default class MenuChecklist extends Vue {
  @Prop({ type: Number }) readonly left!: number
  @Prop({ type: Number }) readonly top!: number
  @Prop({ type: Object as () => CheckboxModel }) readonly items!: CheckboxModel

  @State(state => state.user.me) me!: User

  models: CheckboxModel = {}

  list: string[] = []

  @Watch('models', { deep: true })
  onModelsChanged (val: CheckboxModel) {

  }

  @Watch('items', { deep: true })
  onItemsChanged (val: CheckboxModel) {
    this.models = Object.assign({}, this.items)
    this.list = R.keys(this.items)
  }

  async mounted () {
    this.models = Object.assign({}, this.items)
    this.list = R.keys(this.items)
  }

  onCheckboxClick (item: string) {
    this.models[item] = !this.models[item]
    this.onChange()
    this.items[item] = !this.items[item]
  }

  @Emit('hide')
  hide () {}

  @Emit('change')
  onChange () {
    const key = 'VERGE_WF_CUSTOM_MENU_' + this.me.id

    localStorage.setItem(key, JSON.stringify(this.models))
  }

  @Emit('label-click')
  onLabelClick (name: string) {
    return name
  }
}
